export default [
  { id: 'All time', name: 'All time' },
  { id: 'Today', name: 'Today' },
  { id: 'Yesterday', name: 'Yesterday' },
  { id: 'This week', name: 'This week' },
  { id: 'This month', name: 'This month' },
  { id: 'This quarter', name: 'This quarter' },
  { id: 'This year', name: 'This year' },
  { id: 'Last 7 days', name: 'Last 7 days' },
  { id: 'Last 30 days', name: 'Last 30 days' },
  { id: 'Last week', name: 'Last week' },
  { id: 'Last month', name: 'Last month' },
  { id: 'Last quarter', name: 'Last quarter' },
  { id: 'Last year', name: 'Last year' },
];
